import { useMemo } from 'react';
import { TabContext } from './TabContext.js';
import styles from './Tabs.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import { useControllableState } from '../util/useControllableState.js';
import { HorizontalScrollable } from '../scrollable/HorizontalScrollable.js';
import classNames from 'clsx';

function TabList(props) {
  const {
    border = true,
    className: callerClassName,
    insetSelectionIndicator = false,
    tag,
    size = 'default',
    variant = 'default'
  } = props;
  const [selected, onSelect] = useControllableState(props.selected, props.defaultSelected, props.onSelect);
  const viewportClassName = classNames(styles['tab-list'], styles[`size-${size}`], styles[`variant-${variant}`], border && styles['border'], insetSelectionIndicator && styles['inset-selection-indicator']);
  const contextValue = useMemo(() => ({
    menu: false,
    selected,
    size,
    variant,
    onSelect
  }), [selected, size, variant, onSelect]);
  return /*#__PURE__*/jsx(TabContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/jsx(HorizontalScrollable, {
      className: callerClassName,
      tag: tag,
      viewportClassName: viewportClassName,
      viewportRole: "tablist",
      children: props.children
    })
  });
}

export { TabList };
